import { NavigationErrors } from 'typings/enums';

export class ErrorMessages {
    private _errorMessage: string;

    constructor() {
        this._errorMessage = NavigationErrors.Default;
    }

    setErrorMessage(message: NavigationErrors): void {
        this._errorMessage = message;
    }

    get errorMessage(): string {
        return this._errorMessage;
    }
}